import { gql } from "gql";

export const GET_MODULES_FOR_GLOBAL_WIZARD = gql(/* GraphQL */ `
  query getModulesForGlobalWizard {
    getModulesInfo {
      ...NeedSetupModule
    }
  }
`);
